import React from 'react';

export default class EquationSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {value: 'addition'};
    this.handleEquationSelectChange = this.handleEquationSelectChange.bind(this);
  }

  handleEquationSelectChange(event) {
    this.setState({value: event.target.value});
    this.props.updateEquationSelectChoice(event.target.value);
  }

  render() {
    return (
      <div className="equation-type-select">
        <p className="equation-type-select__label">Choose equation type:</p>
        <div className="equation-type-select__select">
          <form>
            <select
              value={this.state.value}
              onChange={this.handleEquationSelectChange}>
              <option value="addition">Addition</option>
              <option value="subtraction">Subtraction</option>
              <option value="multiplication">Multiplication</option>
              <option value="addition with multiplication">
                Addition With Multiplication
              </option>
            </select>
          </form>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/algebra/equation_select.js
 **/